export const trapFocusFilter = () => {
  const FILTERS_BUTTON_SELECTOR = '.filters-button';
  const FILTERS_PANEL_ID = 'filters';
  const FILTERS_OPEN_CLASS = 'filters-open';

  const FOCUSABLE_SELECTORS = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
    'details > summary',
    'span[tabindex]:not([tabindex="-1"])',
  ].join(', ');

  let triggerButton = null;
  let trapActive = false;

  function getFocusable(panel) {
    return Array.from(panel.querySelectorAll(FOCUSABLE_SELECTORS)).filter(
      el => !el.closest('[hidden]') && el.offsetParent !== null
    );
  }

  function focusFirst(panel) {
    const items = getFocusable(panel);
    if (items.length) items.at(0).focus();
  }

  function handleKeydown(e) {
    if (!trapActive) return;

    const panel = document.getElementById(FILTERS_PANEL_ID);
    if (!panel) return;

    if (e.key === 'Escape') {
      closeFilters();
      return;
    }

    if (e.key !== 'Tab') return;

    const focusable = getFocusable(panel);
    if (!focusable.length) { e.preventDefault(); return; }

    const first = focusable.at(0);
    const last = focusable.at(focusable.length - 1);

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
    }
  }

  function setBackgroundInert(enable) {
    const panel = document.getElementById(FILTERS_PANEL_ID);

    document.querySelectorAll('body > *').forEach(el => {
      if (el === panel || el.contains(panel)) return;
      if (enable) {
        el.setAttribute('inert', '');
        el.setAttribute('aria-hidden', 'true');
      } else {
        el.removeAttribute('inert');
        el.removeAttribute('aria-hidden');
        document.documentElement.classList.remove(FILTERS_OPEN_CLASS);
        document.body.style.top = "";
        window.scrollTo(0, Number.parseInt(scrollY || "0") * -1);
      }
    });
  }

  function openFilters(panel, button) {
    trapActive = true;
    triggerButton = button;

    setBackgroundInert(true);

    document.addEventListener('keydown', handleKeydown);
    focusFirst(panel);
  }

  function closeFilters() {
    trapActive = false;

    document.removeEventListener('keydown', handleKeydown);
    setBackgroundInert(false);

    if (triggerButton) {
      triggerButton.setAttribute('aria-expanded', false);
      triggerButton.focus();
    }
  }

  const panel = document.getElementById(FILTERS_PANEL_ID);
  if (!panel) { console.warn('[FocusTrap] #filters panel not found.'); return; }

  const observer = new MutationObserver(() => {
    const isOpen = document.documentElement.classList.contains(FILTERS_OPEN_CLASS);

    if (isOpen && !trapActive) {
      openFilters(panel, triggerButton);
    } else if (!isOpen && trapActive) {
      closeFilters();
    }
  });

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  });

  document.querySelectorAll(FILTERS_BUTTON_SELECTOR).forEach(btn => {
    btn.addEventListener('click', () => { triggerButton = btn; }, true);
  });
}